// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__19aQM","fromBtn":"login_fromBtn__2g8c9","offset":"login_offset___He6e"};